var chatBoxToggled = false;


document.getElementById("chatIcon").addEventListener('click', function() {
    var chatBox = document.getElementById("chatBox");
    chatBox.classList.toggle('active');
    chatBoxToggled = true;
});


setTimeout(function() {
    if (!chatBoxToggled) {
        var chatBox = document.getElementById("chatBox");
        if (!chatBox.classList.contains('active')) {
            chatBox.classList.add('active');
        }
    }
}, 10000);


document.getElementById("option1").addEventListener('click', function(event) {
    event.preventDefault();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'chat_click'
    });
    setTimeout(function() {
        window.location.href = 'https://m.me/110438508824257';
    }, 100); 
});


document.getElementById("option2").addEventListener('click', function(event) {
    event.preventDefault();
    setTimeout(function() {
        window.location.href = 'https://www.flygmedpoang.se/pages/booking';
    }, 100); 
});
